"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionHeading = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var heading_1 = require("../styled/heading");

var AccordionHeading = function AccordionHeading(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      children = _a.children,
      className = _a.className,
      isLeading = _a.isLeading,
      onClick = _a.onClick,
      isTrailing = _a.isTrailing;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'AccordionHeading',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _b = (0, react_1.useContext)(context_1.AccordionContext),
      controlsId = _b.controlsId,
      isExpanded = _b.isExpanded,
      isDisabled = _b.isDisabled,
      isInverse = _b.isInverse;

  var a11yProps = {};

  if (isExpanded) {
    a11yProps['aria-controls'] = controlsId;
  }

  return react_1.default.createElement(heading_1.Heading, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    isInverse: isInverse,
    onClick: onClick,
    isLeading: isLeading,
    isTrailing: isTrailing,
    "aria-expanded": isExpanded,
    disabled: isDisabled,
    "aria-disabled": isDisabled,
    type: "button"
  }, a11yProps), isLeading && react_1.default.createElement(ui_icon_1.Icon, {
    name: "caret-down",
    isParentColor: true,
    "aria-hidden": true,
    mr: 2
  }), children, isTrailing && react_1.default.createElement(ui_icon_1.Icon, {
    name: "caret-down",
    isParentColor: true,
    "aria-hidden": true,
    ml: 2
  }));
};

var AccordionHeadingWithSpace = (0, ui_helper_with_space_1.withSpace)(AccordionHeading);
exports.AccordionHeading = AccordionHeadingWithSpace;